import type { ProfileState } from "@/features/profile";

type ProfileIdentity = Pick<ProfileState, "myProfile" | "profileNames" | "profileNamesStatus">;

export const hasProfileForAccount = (
  account: string,
  { myProfile, profileNames, profileNamesStatus }: ProfileIdentity
): boolean => {
  if (!account) return false;

  const address = account.toLowerCase();
  if (myProfile.address?.toLowerCase() === address && Boolean(myProfile.name || myProfile.id)) {
    return true;
  }

  return profileNamesStatus === "succeeded" && profileNames.some(
    (profile) => profile.address?.toLowerCase() === address && Boolean(profile.name)
  );
};

export const shouldRedirectToProfileCreation = (
  account: string,
  pathname: string,
  profileState: ProfileIdentity
): boolean =>
  Boolean(account) &&
  profileState.profileNamesStatus === "succeeded" &&
  !["/", "/profile", "/create-profile", "/profile-unboxing"].includes(pathname) &&
  !hasProfileForAccount(account, profileState);

export const isProfileCreationWrite = (
  contractAddress: string,
  functionName: string,
  args: readonly unknown[] | undefined,
  profileAddress: string,
  mafiaAddress: string,
  unboxAddress = ""
): boolean => {
  const address = contractAddress.toLowerCase();
  const profile = profileAddress.toLowerCase();
  const unbox = unboxAddress.toLowerCase();

  return (address === profile && functionName === "createProfile") || (
    Boolean(unbox) && address === unbox &&
    ["createProfileAndUnbox", "requestUnbox", "openUnbox"].includes(functionName)
  ) || (
    functionName === "approve" &&
    typeof args?.[0] === "string" &&
    ((address === mafiaAddress.toLowerCase() && args[0].toLowerCase() === profile) ||
      (Boolean(unbox) && args[0].toLowerCase() === unbox))
  );
};
